import { render, staticRenderFns } from "./choice.vue?vue&type=template&id=a7e9bb0a&scoped=true"
import script from "./choice.vue?vue&type=script&lang=ts"
export * from "./choice.vue?vue&type=script&lang=ts"
import style0 from "./choice.vue?vue&type=style&index=0&id=a7e9bb0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e9bb0a",
  null
  
)

export default component.exports